import { useTranslation } from '@rhino-project/core/i18n';
import { useMemo } from 'react';

import { notificationsEnabled } from '@rhino-project/core/utils';
import { useBaseOwnerId } from '@rhino-project/core/hooks';
import { AccountMenu, NotificationMenu } from '@rhino-project/ui-heroui';
import { Link } from '@tanstack/react-router';
import { Icon } from '@iconify/react';

export const SecondaryNavigation = () => {
  const { t } = useTranslation();

  const showNotifications = useMemo(() => notificationsEnabled(), []);
  const owner = String(useBaseOwnerId());

  return (
    <div className="flex flex-col gap-2">
      {showNotifications && <NotificationMenu />}
      {import.meta.env.DEV && (
        <Link
          to="/$owner/design"
          params={{ owner }}
          className="flex items-center gap-4 px-2 py-2 rounded-lg text-foreground/80 hover:bg-surface-secondary hover:text-foreground"
        >
          <Icon icon="bi:palette" className="text-lg" />
          <span className="text-sm">
            {t('frontend.messages.design_system')}
          </span>
        </Link>
      )}
      <AccountMenu />
    </div>
  );
};
